<template>
  <CollapseAnimation :duration="duration">
    <slot v-if="show" />
  </CollapseAnimation>
</template>

<script>
  import CollapseAnimation from './CollapseAnimation';

  export default {
    name:       'VueCollapse',
    components: {
      CollapseAnimation,
    },
    props:      {
      show:     {
        default:  true,
        type:     Boolean,
        required: false,
      },
      duration: {
        type:     Number,
        required: false,
        default:  250,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/VueCollapse.vue